<template>
  <div>
    <v-layout
      v-if="!formIns"
      fill-height
      align-center
      justify-space-around
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </v-layout> 
    <v-card
      v-if="formIns "
      flat
    >
      <v-card-text style="min-height: 70vh">
        <v-row class=""> 
          <!-- <v-col  
            v-if="id == null"
            cols="12"
            sm="2"
            class="d-flex align-center"
          >
            <v-autocomplete 
              v-model="selectedthemeType"
              :items="themeType"
              label="Theme Type"
              outlined
              hide-details
              dense 
              @change="getFilteredThemeArr(selectedthemeType)"
            />
          </v-col>   

          <v-col
            v-if="selectedthemeType"
            cols="12"
            sm="2"
            class="d-flex align-center"
          >
            <v-autocomplete
              v-model="selectedthemeId"
              :items="themesList"
              item-text="themename"
              item-value="id"
              label="Select theme"
              outlined
              hide-details
              dense
              @change="fetchNewTheme(selectedthemeId)"
            />
          </v-col>  -->  
          <v-col
            sm="2"
            cols="12"
            class="d-flex align-center"
          >
            <v-text-field
              v-model="formIns.name"
              label="Name"
              outlined
              hide-details
              dense
            /> 
          </v-col> 
          <v-col
            cols="12"
            sm="3"
            class="d-flex align-center" 
          >
            <v-text-field
              v-model="formIns.themes.id"
              outlined
              hide-details
              label="Theme Id"
              dense
            />
          </v-col>

          <!-- <v-col
            cols="12"
            sm="2"
            class="d-flex align-center"
             :class="{ 'invisible': id !== null }"
          >
            <v-text-field
              v-model="selectedtheme"
              label="SelectedTheme"
              outlined
              hide-details
              dense
              readonly
            /> 

        
            
          </v-col>    -->
          
         
          <!-- <v-col :class="{ 'invisible': id !== null }">
            <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">

        <v-icon class="" @click="handleDialog()"  color="primary"
          dark
          v-bind="attrs"
          v-on="on">mdi-cookie-edit-outline</v-icon>
      </template>
      <span>Edit theme</span>
    </v-tooltip>
          </v-col> -->
        
          
          <v-col
            cols="12"
            sm="7"
          >
            <v-row class="align-center">
              <v-col
                cols="12"
                class="text-xs-right"
              >
                <v-tabs
                  v-model="contactlessTab"
                  right
                  bg-color="red-lighten-2"
                >
                  <v-tab> Theme </v-tab>
                  <v-tab> Settings </v-tab>
                  <v-tab> Helpers </v-tab>
                </v-tabs>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
       
        <v-row>
          <v-col cols="12">
            <v-tabs-items
              v-model="contactlessTab"
              bg-color="primary"
            >
              <v-tab-item>
                <ContactlessTheme
                  :id="id"
                  :enable="enable"
                  :theme-info="formIns" 
                  :images="images"
                  @close="close"
                  @enableDialog="handleDialog"
                />
              </v-tab-item>
              <v-tab-item>
                <ContactlessSettings
                  :id="id"
                  :theme-info="formIns"
                  :enable="enable"
                  @close="close"
                />
              </v-tab-item>
              <v-tab-item>
                <ContactlessHelpers
                  :id="id"
                  :theme-info="formIns"
                  @close="close"
                />
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>   
    <v-row>
      <v-dialog
        v-model="enableDialog"
        max-width="430px"
        min-height="190px" 
        persistent
      >
        <v-card
          flat
          tile
        > 
          <v-card-title>
            <span>Select Theme</span>
          </v-card-title>
          <v-card-text class="my-7 red-lighten-2">
            <v-row>
              <v-col
                cols="12"
                sm="12"
              >
                <v-autocomplete
                  v-model="selectedthemeType"
                  :items="themeType"
                  label="Theme Type"
                  outlined
                  hide-details
                  dense
                  @change="getFilteredThemeArr(selectedthemeType,'themeType')"
                />
              </v-col>
              <v-col 
                cols="12"
                sm="12"
                class="d-flex align-center"
              >
                <v-autocomplete
                  v-model="selectedthemeId"
                  :items="themesList"
                  item-text="themename"
                  item-value="id"
                  label="Theme name"
                  outlined
                  hide-details
                  dense
                  :disabled="!selectedthemeType"
                />
              </v-col> 
            </v-row>
          </v-card-text>
          <v-card-actions class="d-flex justify-end">
            <v-btn
              class="red--text"
              outlined
              @click="onSkip()"
            >
              Skip
            </v-btn>
            <v-btn
              color="green"
              class="white--text"
              :disabled="isThemeSelected"
              @click="applyTheme(selectedthemeId)"
            >
              Apply
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
const newFormIns = () => {
  return {
    name: "",
    themes: {
      id: "",
      light: {},
      dark: {},
      images: {
        logo: null,
        bg: null,
        home: null,
        confirmOrder: null
      }
    },
    settings: {
      homePageType: 1,
      logoPosition: 1,
      showLogo: true,
      firstLvlTemplate: 0,
      secondLvlTemplate: 0,
      menuTemplate: 0
    }
  };
};

import { failure } from "@/mixins/common";
import ContactlessTheme from "@/components/contactless/edit/Theme";
import ContactlessSettings from "@/components/contactless/edit/Settings";
import ContactlessHelpers from "@/components/contactless/edit/Helpers";
import {ThemesObj} from "@/store/helper.js";


export default {
  name: "Contactless",
  components: {
    ContactlessTheme,
    ContactlessSettings,
    ContactlessHelpers
  },
  mixins: [failure],
  props: {
    enable: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number || null,
      default: null
    }
  },
  data() {
    return {
      allImages:[],
      loader: true,
      accountId: parseInt(this.$route.params.accountId),
      tab: 0,
      themes: ["Light", "Dark"],
      images: [
        { id: "logo", title: "Logo", value: null },
        { id: "bg", title: "Background", value: null },
        { id: "home", title: "Home", value: null },
        { id: "confirmOrder", title: "Confirm Order", value: null }
      ],
      formIns: null,
      homePageTypes: [
        {id: 1, label: "First"},
        {id: 2, label: "Second"}
      ],
      contactlessTab: 0,
      themeType:["Regular-(Default)","Block Design - All","Block design- Upto category level"],
      selectedthemeType:"",
      themesObj:ThemesObj,
      themesList:[],
      selectedthemeId:"",
      selectedtheme:"",
      enableDialog:false,
      themeName:"",
      themeId:"",
      appliedThemeId:"",
      appliedThemeType:""


    };
  },
  computed:{
    isThemeSelected(){
       if(this.selectedthemeId && this.selectedthemeType){
        return false;
       }
       return true;
    }
  },
  created() {
    this.get();  

   

    if(this.id===null){
      this.enableDialog = true;

      const defaultTheme = ThemesObj.find(item => item.themename.toLowerCase() === "default theme");

    if (defaultTheme) {
      this.getFilteredThemeArr(defaultTheme.type); 
      this.selectedthemeId = defaultTheme.id;
      this.selectedtheme = defaultTheme.themename;
      this.selectedthemeType = "Regular-(Default)";
      this.appliedThemeId = defaultTheme.id;
      this.appliedThemeType = "Regular-(Default)";
    
    }  
  }
},
  methods: {
    get() {
      this.loader = true;

      // 1. Handle new theme initialization
      if (!this.id) {
        this.formIns = newFormIns();
        this.loader = false;
        return;
      }

      // 2. FETCH THE THEME FIRST
      const themeUrl = `${this.ADMIN_API_URL}/accounts/${this.accountId}/contactless/${this.id}`;

      this.$http.get(themeUrl).then((res) => {
        this.formIns = res.body || {};

        // 3. THE BRIDGE: Fetch Gallery to translate Integers back to Objects
        // We need the 'imgId' (String UUID) which is NOT stored in the contactless DB
        return this.$http.get(`${this.ADMIN_API_URL}/accounts/${this.accountId}/images?limit=500`);
      }).then((galleryRes) => {
        const allImages = galleryRes.body.data || galleryRes.body || [];

        if (this.formIns.themes && this.formIns.themes.images) {
          this.images.forEach((img) => {
            const storedId = this.formIns.themes.images[img.id];

            if (storedId) {
              // Find the matching object in the gallery list
              const found = allImages.find(i => String(i.id) === String(storedId));

              if (found) {
                // Success: img.value is now an Object with a String UUID
                img.value = found;
              } else {
                // Fallback: Create a basic object so the UI doesn't crash
                img.value = { id: storedId, imgId: String(storedId) };
              }
            } else {
              img.value = null;
            }
          });
        }

        this.loader = false;
        this.themeName = this.formIns.name;
      }).catch((err) => {
        this.loader = false;
        console.error("Get flow failed:", err);
        if (this.handleFailure) this.handleFailure(err);
      });
    },
    close() {
      this.$emit("update:enable", false);
    },
    getFilteredThemeArr(Themetype,flag){ 
      if(flag!=="Dialog"){
        this.selectedthemeId="";
      }
      this.themesList  = ThemesObj.filter((item) => item.type === Themetype);
    },
  


    changeSelectedThemeType(selectedTheme) {

      this.formIns.themes.light = selectedTheme.themes.light;
      this.formIns.themes.dark = selectedTheme.themes.dark;
      this.formIns.settings.homePageType = selectedTheme.settings.homePageType;
      this.formIns.settings.logoPosition = selectedTheme.settings.logoPosition;
      this.formIns.settings.showLogo = selectedTheme.settings.showLogo;
      this.formIns.settings.firstLvlTemplate = selectedTheme.settings.firstLvlTemplate || 0;
      this.formIns.settings.secondLvlTemplate = selectedTheme.settings.secondLvlTemplate;
      this.formIns.settings.menuTemplate = selectedTheme.settings.menuTemplate; 
      // TODO: reset selected fields as sent
    },
    applyTheme(themeID) { 

    
      if (!themeID) {
        return;
      }
      
      if (themeID === 11) { // default theme
        const defaultTheme = newFormIns(); 
        this.appliedThemeType = "Regular-(Default)";
        this.appliedThemeId = 11;
        this.selectedtheme = "Default Theme";
        this.changeSelectedThemeType(defaultTheme);
      }else{ 

        const selectedTheme = this.$store.getters.getThemeById(themeID); 
        let filterthemeList;
        filterthemeList  = ThemesObj.find((item) => item.id === selectedTheme.id );
         
        this.selectedthemeId = filterthemeList.id; 
        
      this.selectedthemeType = filterthemeList.type; 
      this.appliedThemeId = filterthemeList.id;
      this.appliedThemeType = filterthemeList.type; 
      this.selectedtheme = filterthemeList.themename;
      this.changeSelectedThemeType(selectedTheme);
      }

      /** use themeID to get theme */
    

      this.enableDialog = false;
      // TODO: verify if needed
      // if (!this.formIns.settings) {
      //   this.formIns.settings = { homePageType: 1 };
      // }
    },
    handleDialog(){
    
      let filterthemeList; 

      if(this.selectedtheme){
         filterthemeList  = ThemesObj.find((item) => item.themename.toLowerCase() === this.selectedtheme.toLowerCase() ); 
        

         this.getFilteredThemeArr(filterthemeList.type,"Dialog");
 
      }


      
      this.enableDialog = true;
    },
    onSkip(){
      this.enableDialog = false;
      this.selectedthemeId = this.appliedThemeId;
      this.selectedthemeType = this.appliedThemeType;
    }
   
    
  }


};
</script> 
<style>
.invisible {
  visibility: hidden;
}



</style>